import { Injectable } from '@angular/core';

/**
 * TenantService (Angular 18).
 *
 * Replaces the AngularJS legacy service at:
 *   apps/b2b-ui/common/services/tenant/tenant.service.js
 *
 * Exposed to AngularJS via `downgradeInjectable` under the same name
 * `'TenantService'`, so existing consumers in b2b-ui keep working without
 * modification (see ng-downgraded-components.ts).
 */
@Injectable({ providedIn: 'root' })
export class TenantService {
  model: Record<string, unknown> = {};

  setModel(data: unknown): void {
    this.model = data == null ? {} : (data as Record<string, unknown>);
  }

  isRecurringPaymentEnabled(): boolean {
    return (
      Object.prototype.hasOwnProperty.call(this.model, 'recurringPaymentEnabled') &&
      Boolean(this.model.recurringPaymentEnabled)
    );
  }
}